import api from "../api";

const schoolAiApi = {
  capabilities: () => api.get("/school-ai/capabilities"),
  ask: (question, history = [], context = null) => api.post("/school-ai/ask", { question, history, context }),
};

export default schoolAiApi;
